// Utils
import { currencyFormatter } from "../../utils/Utils";

// Material-ui imports
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";

export function ShipmentOptionsTableRow({ line, staff, shipmentDate }) {
  const getStaffbyLineNo = (lineNo) => {
    const person = staff.find((person) => person.staffLineNo == lineNo);
    return `${person?.name} (${person?.yourId})`;
  };

  return (
    <TableRow sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
      <TableCell>{getStaffbyLineNo(line.staffLineNo)}</TableCell>
      <TableCell>{line.productName}</TableCell>
      <TableCell>{line.colour}</TableCell>
      <TableCell>{line.size}</TableCell>
      <TableCell>{line.fit}</TableCell>
      <TableCell>{line.freeStockQty}</TableCell>
      <TableCell>{currencyFormatter("GB", line.cost)}</TableCell>
      <TableCell>{line.quantity}</TableCell>
      <TableCell>
        {currencyFormatter("GB", line.cost * line.quantity)}
      </TableCell>
      <TableCell>{line.sla_date}</TableCell>
      <TableCell>{line.returnPeriod}</TableCell>
      <TableCell>{shipmentDate}</TableCell>
    </TableRow>
  );
}
